var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoleto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 84,
    viewBox: "0 0 77 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 33,
    height: 33,
    rx: 4,
    fill: "#453CBB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 27,
    height: 27,
    rx: 4,
    fill: "#88F4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5518,
    y: 46.0299,
    width: 9.06002,
    height: 9.06002,
    rx: 1,
    fill: "#88F4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67.9399,
    y: 46.0299,
    width: 9.06002,
    height: 9.06002,
    rx: 1,
    fill: "#219BE4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67.9399,
    y: 74.72,
    width: 9.06002,
    height: 9.06002,
    rx: 1,
    fill: "#219BE4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.5518,
    y: 74.72,
    width: 9.06002,
    height: 9.06002,
    rx: 1,
    fill: "#88F4FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3501,
    y: 59.6199,
    width: 9.06002,
    height: 9.06002,
    rx: 1,
    fill: "#334588"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 49,
    width: 7,
    height: 7,
    rx: 1,
    fill: "#F5F5F5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#88F4FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    width: 37.7501,
    height: 37.7501,
    rx: 4,
    fill: "#219BE4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3501,
    y: 15.1,
    width: 9.06002,
    height: 9.06002,
    rx: 1,
    fill: "#F5F5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoleto);
export default __webpack_public_path__ + "static/media/boleto.9806a9dc634ccb63a0b15bdb50dc5305.svg";
export { ForwardRef as ReactComponent };